function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-77 -92.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_3",
  "data-name": "Subtraction 3",
  d: "M2214.029-1566.328h0a66.606,66.606,0,0,0-8.744-7.057,65.976,65.976,0,0,0-11.211-6.085,66.05,66.05,0,0,0-6.835-2.457L2231.743-1656l26.571,15.966Z",
  transform: "translate(-2037.382 1801.159)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_5",
  "data-name": "Subtraction 5",
  d: "M2214.029-1566.328h0a66.606,66.606,0,0,0-8.744-7.057,65.976,65.976,0,0,0-11.211-6.085,66.05,66.05,0,0,0-6.835-2.457L2231.743-1656l26.571,15.966Z",
  transform: "translate(2716.245 1359.474) rotate(-121)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_7",
  "data-name": "Subtraction 7",
  d: "M2214.029-1566.328h0a66.606,66.606,0,0,0-8.744-7.057,65.976,65.976,0,0,0-11.211-6.085,66.05,66.05,0,0,0-6.835-2.457L2231.743-1656l26.571,15.966Z",
  transform: "matrix(-0.407, 0.914, -0.914, -0.407, -295.394, -2451.931)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  cx: 54,
  cy: 54,
  r: 54,
  transform: "translate(351 229.5) rotate(90)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: 54,
  cy: 54,
  r: 54,
  transform: "translate(185 228.5) rotate(90)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  cx: 54,
  cy: 54,
  r: 54,
  transform: "translate(267 92.5) rotate(90)",
  fill: "currentColor"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 245.049,
    viewBox: "0 0 274 245.049",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.b572fca9.svg";
export { ForwardRef as ReactComponent };